var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"listbox d-flex align-items-center"},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }